import SectionHeading from "./SectionHeading";
import { events } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  已补档: "bg-accent-100 text-accent-800",
  进行中: "bg-primary-100 text-primary-700",
  已归档: "bg-secondary-100 text-secondary-800",
};

export default function EventTimeline() {
  return (
    <section id="events" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="05"
          eyebrow="Event Tracker"
          title="事件追踪 · 按时间线补档"
          desc="每起事件以时间线呈现，标注当前收录进度与补档状态。点开即可看到该事件从最早到最新的全部图集，判断内容是否已经收录完整。"
        />

        <div className="mt-10 max-w-3xl">
          {events.map((item, index) => (
            <div key={item.title} className="relative flex gap-4 md:gap-6">
              <div className="hidden w-24 shrink-0 pt-2 text-right md:block">
                <span className="font-heading text-sm font-bold text-foreground-900">{item.date}</span>
              </div>

              <div className="relative flex flex-col items-center">
                <span className="mt-2 flex h-4 w-4 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50">
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                </span>
                {index !== events.length - 1 ? <span className="w-px flex-1 bg-background-300"></span> : null}
              </div>

              <div className={`flex-1 ${index !== events.length - 1 ? "pb-8" : ""}`}>
                <div className="rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300">
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-heading text-xs font-bold text-foreground-500 md:hidden">{item.date}</span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${statusStyle[item.status]}`}>
                      {item.status}
                    </span>
                    <span className="ml-auto flex items-center gap-1 text-xs font-semibold text-accent-700">
                      <i className="ri-stack-line text-sm"></i>
                      {item.count} 张
                    </span>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <a
                    href="#latest"
                    className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-500"
                  >
                    打开事件图集
                    <i className="ri-arrow-right-line text-base"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}